import { DashboardService } from "@/services/dashboard/dashboard.service";

const _dashboardService = new DashboardService();

const getSuperAdminMetricsAction = ({ commit }, { callback }) => {
  _dashboardService
    .getSuperAdminMetrics()
    .then((response) => {
      callback(response.data);
    })
    .catch((err) => {
      console.log(err);
    });
};

const getSpaceAdminMetricsAction = ({ commit }, { spaceId, callback }) => {
  _dashboardService
    .getSpaceMetrics(spaceId)
    .then((response) => {
      callback(response.data);
    })
    .catch((err) => {
      console.log(err);
    });
};
const getSuperSpaceAdminMetricsAction = (
  { commit },
  { superSpaceId, callback }
) => {
  _dashboardService
    .getSuperSpaceMetrics(superSpaceId)
    .then((response) => {
      callback(response.data);
    })
    .catch((err) => {
      console.log(err);
    });
};

export default {
  getSuperAdminMetricsAction,
  getSpaceAdminMetricsAction,
  getSuperSpaceAdminMetricsAction,
};
